const cartPopoverConfig = {
    minimumOrderValue: {
        1: 12.0,
        2: 19.0,
        3: 10.0,
        4: 9.0,
        7: 9.0,
        8: 2.0,
        11: 19.0,
        12: 9.0,
        14: 15.0,
        15: 15.0,
        16: 11.96,
        18: 19.0,
        19: 5.0,
        20: 14.0,
        21: 14.9,
        22: 15.96,
        23: 15.0,
        24: 9.8,
        25: 19.0,
        26: 19.9,
        28: 19.0,
        29: 10.0,
        30: 12.5,
        31: 29.9,
        32: 29.0,
        33: 12.0,
        101: 14.0,
        103: 15.0,
        104: 15.0,
        107: 9.0,
        108: 2.0,
        112: 15.0,
        114: 19.0,
        115: 15.0,
        116: 11.96,
        118: 19.0,
        121: 14.9,
        125: 19.0,
        126: 19.9,
        102: 0,
        111: 0,
        119: 0,
        122: 0,
        123: 0,
        124: 0,
        128: 0,
    },
};

export { cartPopoverConfig as default };
//# sourceMappingURL=cartPopoverConfig.js.map
